interface OfflineIndicatorProps {
  isOnline: boolean;
  pendingCount: number;
}

export default function OfflineIndicator({ isOnline, pendingCount }: OfflineIndicatorProps) {
  if (isOnline && pendingCount > 0) {
    return (
      <div className="syncing-banner">
        <span>Syncing {pendingCount} event{pendingCount > 1 ? 's' : ''}...</span>
      </div>
    );
  }

  if (!isOnline && pendingCount > 0) {
    return (
      <div className="offline-banner">
        <span>You are offline — {pendingCount} event{pendingCount > 1 ? 's' : ''} pending sync</span>
      </div>
    );
  }

  if (!isOnline) {
    return (
      <div className="offline-banner">
        <span>You are offline</span>
      </div>
    );
  }

  return null;
}
